module.exports = __webpack_public_path__ + "img/produit_labellise.cab53702.svg";